import { cn } from '../../lib/utils'

const variants = {
  primary: 'bg-teal text-white hover:bg-teal-600 active:bg-teal-700',
  secondary: 'bg-navy text-white hover:bg-navy-800',
  outline: 'bg-white border border-gray-200 text-navy hover:bg-graysoft',
  ghost: 'bg-transparent text-navy hover:bg-graysoft',
  danger: 'bg-red-500 text-white hover:bg-red-600',
  gold: 'bg-gold text-white hover:bg-gold-600',
}

const sizes = {
  sm: 'px-3 py-2 text-xs rounded-lg',
  md: 'px-4 py-2.5 text-sm rounded-xl',
  lg: 'px-6 py-3 text-base rounded-xl',
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  icon: Icon,
  loading = false,
  ...props
}) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 font-semibold',
        'transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        sizes[size],
        className
      )}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? (
        <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
      ) : (
        Icon && <Icon className="w-4 h-4" />
      )}
      {children}
    </button>
  )
}